module.exports = __webpack_public_path__ + "static/media/faqBalance-es-ar.db066acc.vtt";